export const i18nKeyPrefix: string = 'DASHBOARD-PAYMENTS-PAYMENT-SETTINGS'
